import { FC } from 'react';
import Icon from '@cloudscape-design/components/icon';
import TextContent from '@cloudscape-design/components/text-content';
import { IconProps } from '@cloudscape-design/components/icon';

interface StatusIndicatorProps {
  value: number | string;
  label: string;
  variant: 'horizontal' | 'vertical';
  backgroundColor?: string;
  textColor?: string;
  className?: string;
  loading?: boolean;
  icon?: IconProps.Name; // Optional Cloudscape icon name - always appears before content
}

const StatusIndicator: FC<StatusIndicatorProps> = ({
  value,
  label,
  variant,
  backgroundColor,
  textColor,
  className = '',
  loading = false,
  icon,
}) => {
  const displayValue = loading ? '...' : value;

  // Build the className string
  const combinedClassName =
    `status ${backgroundColor || ''} ${textColor || ''} ${className}`.trim();

  if (variant === 'horizontal') {
    return (
      <TextContent>
        <p className={combinedClassName}>
          {icon && (
            <>
              <Icon name={icon} />{' '}
            </>
          )}
          {label}{' '}
          <strong>
            <span className="font-x_large">{displayValue}</span>
          </strong>
        </p>
      </TextContent>
    );
  }

  // Vertical variant
  return (
    <TextContent>
      <div className={combinedClassName}>
        {icon && (
          <div style={{ marginBottom: '4px' }}>
            <Icon name={icon} />
          </div>
        )}
        <div style={{ marginBottom: '4px' }}>{label}</div>
        <div>
          <strong>
            <span className="font-x_large">{displayValue}</span>
          </strong>
        </div>
      </div>
    </TextContent>
  );
};

export default StatusIndicator;
